import { CONTACT } from '../data/contact';

/**
 * Submit a lead via Formspree.
 * Set REACT_APP_FORMSPREE_ID to your form id (e.g. xyzabcde).
 * Falls back to a clear error pointing at CONTACT.email when unset.
 */
export async function submitLead(fields) {
  const formId = process.env.REACT_APP_FORMSPREE_ID;
  if (!formId) {
    throw new Error(
      `Form endpoint not configured. Email us at ${CONTACT.email}`
    );
  }

  const payload = {
    name: fields.name?.trim() || '',
    email: fields.email?.trim() || '',
    message: fields.message?.trim() || '',
    _subject: fields.subject || 'LogitsLab website inquiry',
  };

  if (fields.phone) payload.phone = fields.phone.trim();
  if (fields.intent) payload.intent = fields.intent;
  if (fields.source) payload.source = fields.source;

  const res = await fetch(`https://formspree.io/f/${formId}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    const detail =
      data?.errors?.map((e) => e.message).join(' ') ||
      data?.error ||
      `Could not send. Email ${CONTACT.email}`;
    throw new Error(detail);
  }

  return data;
}
